<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <!-- Form Section - Informações Básicas -->
  <div class="form-section">
    <h3 class="form-section-title">
      <mat-icon>info</mat-icon>
      Informações do Grupo
    </h3>
    <form [formGroup]="form">
      <div class="form-grid cols-2">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Nome do Grupo</mat-label>
          <input matInput type="text" formControlName="name" />
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Tipo de Empresa</mat-label>
          <mat-select placeholder="Selecione o tipo" formControlName="userType">
            <mat-option value="MICHELIN">Michelin</mat-option>
            <mat-option value="DEALERSHIP">Concessionária (CC)</mat-option>
            <mat-option value="AUTOMAKER">Montadora (OE)</mat-option>
            <mat-option value="DISTRIBUTOR">Distribuidor Exclusivo (DE)</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </div>

  <!-- Permissions Section -->
  <div class="form-section">
    <h3 class="form-section-title">
      <mat-icon>security</mat-icon>
      Permissões do Grupo
    </h3>
    
    @if (readonly) {
      <div class="permissions-readonly">
        @for (permission of formData.permissions; track permission; let i = $index) {
          <div class="permission-item">
            <mat-icon class="permission-icon">check_circle</mat-icon>
            <span>{{ "permissions." + permission.userFunction.name | translate }}</span>
          </div>
        }
      </div>
    } @else {
      <form [formGroup]="form">
        <div class="permissions-grid" formArrayName="permissionsIds">
          @for (permission of permissions.controls; track permission; let i = $index) {
            <mat-checkbox [formControlName]="i" class="permission-checkbox">
              {{ "permissions." + data.permissions[i].name | translate }}
            </mat-checkbox>
          }
        </div>
      </form>
    }
  </div>
</mic-spinner-overlay>
